import { render, staticRenderFns } from "./TransactionDetailComponent.vue?vue&type=template&id=6c27e652&"
import script from "./TransactionDetailComponent.vue?vue&type=script&lang=js&"
export * from "./TransactionDetailComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports